import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";
import SingleLineLoader from "./singleLineLoader";

let style = Object.assign({}, global);

const SignatureLoader = ({ count }) => {
  return [...Array(count)].map((_, i) => (
    <React.Fragment key={i}>
      <li className={cx(style["skeleton-loader-area"])}>
        {/* <SingleLineLoader width={35} height="24px" />
        <SingleLineLoader width={50} height="24px" /> */}
        <div className={cx(style["mr-2"], style["left"])}>
          <span className={style["loader-item"]}></span>
        </div>
        <div className={cx(style["right"], style["w-75"])}>
          <span className={cx(style["loader-item"], style["w-75"], style["mb-2"])}></span>
          <span className={cx(style["loader-item"], style["w-100"])}></span>
        </div>
      </li>
    </React.Fragment>
  ));
};
//Props type validation
SignatureLoader.propTypes = {
  count: PropTypes.number.isRequired,
};

export default SignatureLoader;
